import { useState } from 'react';
import { useIntl } from "react-intl";
import moment from 'moment';

//Components
import { IconButton, Icon } from '@mui/material';
import { Tooltip } from '@gpstrackit/react-controls';
import ChipStatus from 'Components/ChipStatus';

//Helpers
import { getDateFormatted } from 'Core/data/Helpers';

//Styles
import './index.scss'

const DETAILS_TO_COPY = [
    "sm", "email", "brand", "id", "createdOn", "updateOn", "pulsCustomerId", "reference", "imei", "communicationPlan", "dateActivated", "ratePlan", "customer", "Account: Href", "Manufacturing: Href", "Device Configuration: Href", "_self: Href", "IMSI", "airId", "Type: Href", "iccid", "name"
]

const DETAILS_DATE = ["createdOn", "updateOn", "dateActivated", "dateAdded", "dateUpdated", "dateShipped", "shippedDate", "downloadRequestTime", "lastUpdateTime", "lastIdReportTime", "lastConfigUpdateTime", "lastConfigSyncTime", "manufactureDate", "firstIdReportTime", "endDate", "startDate", "time", "gpsTime", "Time" , "System Time"]

const DETAILS_NOT_ADMITTED = ["0", "_id"]

const CopyPaste = ({ value }) => {
    const { messages } = useIntl();
    const [copied, setCopied] = useState(false);

    const handleClick = () => {
        navigator.clipboard.writeText(value);
        setCopied(true);
        setTimeout(() => {
            setCopied(false);
        }, 1000);
    };

    return (
        <div>
            <Tooltip title={copied ? `¡${messages['common_copied']}!` : messages?.['common_copy'] || 'Copy'}>
                <IconButton
                    className={copied ? 'summary-copied' : ''}
                    style={{ padding: 0, marginRight: 5 }}
                    onClick={handleClick}
                    size="large">
                    <Icon style={{ fontSize: 18, color: '#454a4f' }}>content_copy</Icon>
                </IconButton>
            </Tooltip>
        </div>
    );
}

const Summary = ({ data, columns = 2, timezone, addDash, noSort, noParent }) => {
    const { messages } = useIntl();
    const renderValue = (value, key) => {
        if (key && DETAILS_DATE.includes(key)) { 
            const regex = /^\d+$/;
            let currentValue = value
            return currentValue ? getDateFormatted(currentValue, regex.test(currentValue) ? "long" : "date", "datetime", null, timezone): ''
        }

        if (Array.isArray(value)) {
            return value.map((item) => renderValue(item));
        }

        if ((typeof value === 'boolean') && value !== null) {
            return `${messages[`boolean_${value}`]}` || ''
        }

        if (!isNaN(value) && value !== null) {
            return `${value}` || ''
        }

        return value?.length ? value : addDash ? " - " : ""
    }

    const flattenObject = (obj) => {
        const flattened = {};
        Object.keys(obj).forEach((key) => {
            if (typeof obj[key] === 'object' && obj[key] !== null) {
                const flattenedChild = flattenObject(obj[key]);
                Object.keys(flattenedChild).forEach((childKey) => {
                    if(noParent){
                        flattened[`${messages[childKey] || childKey}`] = flattenedChild[childKey];
                    }else {
                        flattened[`${messages[key] || key}: ${messages[childKey] || childKey}`] = flattenedChild[childKey];
                    }
                });
            } else {
                flattened[key] = obj[key];
            }
        });
        return flattened;
    }

    const containerClass = `summary-container summary-columns-${columns}`;
    const object = data ? flattenObject(data) : {}
    const objectOrdered = noSort ? object : Object.fromEntries(Object.entries(object).sort());

    const summaryItems = Object.keys(objectOrdered).map((key) => {
        let copyValidation = DETAILS_TO_COPY.includes(key)
        if (!DETAILS_NOT_ADMITTED.includes(key)) {
            let component = null
            let value = renderValue(objectOrdered[key], key)
            if (value?.length > 15) component = <Tooltip title={value}><span>{value}</span></Tooltip>
            else component = <span>{value ? value : addDash ? " - " : ""}</span>

            return (
                <div key={key} className="summary-item">
                    <div className="summary-item-key">{messages[key] || key}</div>
                    <div className="summary-item-value">
                        {key === 'status' && typeof objectOrdered[key] !== "string" ? <ChipStatus statusCode={objectOrdered[key]} messages={messages} /> : <div className='summary-item-value-data'>{component}</div>}
                        {copyValidation && objectOrdered[key] ? <CopyPaste value={objectOrdered[key]} /> : <></>}
                    </div>
                </div>
            )
        }
    });
    return <div className={containerClass}>{summaryItems}</div>;
}

export default Summary;